import { Building2, Check, ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from '@/components/ui/dropdown-menu';

import { useMe } from '../hooks/useMe';
import { useAvailableInvestors, useSwitchInvestor } from '@/portal/auth/hooks';

export function PortalInvestorSwitcher() {
  const { data: me } = useMe();
  const { data: available } = useAvailableInvestors({
    enabled: me?.investor != null,
  });
  const availableInvestors = available?.investors;
  const switchInvestor = useSwitchInvestor();

  const investor = me?.investor;

  const hasMultipleInvestors =
    availableInvestors && availableInvestors.length > 1;

  const handleSwitchInvestor = (contactId: string) => {
    const selectedInvestor = availableInvestors?.find(
      (inv) => inv.contact_id === contactId
    );
    if (selectedInvestor?.investor_id === investor?.id) {
      return;
    }
    switchInvestor.mutate(contactId);
  };

  if (!investor?.name) {
    return null;
  }

  return (
    <div className="hidden sm:flex items-center gap-3">
      {hasMultipleInvestors ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-accent transition-colors">
              <Building2 className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm font-medium text-foreground">
                {investor.name}
              </span>
              <ChevronDown className="h-3 w-3 text-muted-foreground" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-64">
            <DropdownMenuLabel className="text-xs text-muted-foreground">
              Switch Investor
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            {availableInvestors?.map((inv) => (
              <DropdownMenuItem
                key={inv.contact_id}
                onClick={() => handleSwitchInvestor(inv.contact_id)}
                className="cursor-pointer"
                disabled={switchInvestor.isPending}
              >
                <Check
                  className={cn(
                    'mr-2 h-4 w-4',
                    investor?.id === inv.investor_id
                      ? 'opacity-100'
                      : 'opacity-0'
                  )}
                />
                <div className="flex flex-col flex-1 min-w-0">
                  <span className="truncate font-medium text-sm">
                    {inv.investor_name}
                  </span>
                  <span className="text-xs text-muted-foreground truncate">
                    {inv.investor_type}
                  </span>
                </div>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <div className="flex items-center gap-2">
          <Building2 className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">
            {investor.name}
          </span>
        </div>
      )}
    </div>
  );
}
